import { lazy } from 'react';

const CharityVettingSubmitFoodHygieneCertificateRoute = lazy(
  () =>
    import(
      /* webpackChunkName: "SubmitFoodHygieneCertificate" */ '../components/steps/submit-food-hygiene-certificate-step/SubmitFoodHygieneCertificate'
    ),
);

export default CharityVettingSubmitFoodHygieneCertificateRoute;
